module.exports = __webpack_public_path__ + "static/media/photo2.b795dd41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/photo2.jpg
// module id = 367
// module chunks = 0